
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Container } from "@/components/ui/Container";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const ThankYouPage = () => {
  // Custom hook to set response headers
  useEffect(() => {
    // This will run on the server when pre-rendering with React-Snap
    if (typeof document !== 'undefined') {
      const meta = document.createElement('meta');
      meta.httpEquiv = 'X-Robots-Tag';
      meta.content = 'noindex, nofollow';
      document.head.appendChild(meta);
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Thank You | Fledgio Rust Course Launch Campaign</title>
        <meta name="description" content="Thank you for your interest in our Rust course launch campaign." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="py-12 md:py-20 bg-gradient-to-b from-gray-50 to-white min-h-screen flex items-center">
        <Container className="max-w-3xl">
          <div className="bg-white shadow-lg rounded-lg overflow-hidden p-8 md:p-12 text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-6">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            
            <h1 className="text-2xl md:text-3xl font-bold mb-4">Thank You!</h1>
            
            <div className="mb-8 text-gray-700 space-y-4">
              <p className="text-lg">
                Thank you for your interest in Fledgio and helping to celebrate our launch!
              </p>
              <p className="text-lg">
                We will be in touch shortly as we may just have to ask a couple of questions – remember it's only one place available per company, so we may need to play arbitrator!
              </p>
            </div>
            
            <div className="flex flex-col md:flex-row gap-4 justify-center">
              <Button asChild variant="outline">
                <Link to="/">Return to Homepage</Link>
              </Button>
              <Button asChild>
                <Link to="/courses">Explore Our Courses</Link>
              </Button>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default ThankYouPage;
